// extracted by mini-css-extract-plugin
export default {"Block":"kWxHYWttmRzzlVpr8ugm","Block--boxed":"IKaEBarsjhNxLqUNt704","Block--square":"jM7WtrAeAaWcDvkG7qQf","Block--link":"Dfcx_eqRhdWHUwfLkgv1"};